var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title + "-批量发放",
            visible: _vm.dialogFormVisible,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "div",
            [
              _c("el-alert", {
                staticStyle: { "margin-bottom": "20px" },
                attrs: {
                  title:
                    "温馨提示: 员工状态为禁用的员工不能进行积分发放。请上传Excel文件进行批量发放。",
                  type: "warning",
                  closable: false,
                  "show-icon": "",
                },
              }),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "formRef",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.formRules,
                    "label-width": "120px",
                  },
                },
                [
                  _c("el-form-item", { attrs: { label: "批量上传：" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "align-items": "flex-start",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c(
                              "ButtonUploadExcel",
                              {
                                attrs: {
                                  onSuccess: _vm.onSuccess,
                                  getFileObject: _vm.handleFileObject,
                                },
                              },
                              [
                                _vm._v(
                                  "\n                上传文件\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: { click: _vm.download },
                              },
                              [_vm._v("下载模板")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.uploadFileName
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  "margin-top": "6px",
                                  "font-size": "12px",
                                  color: "#909399",
                                  display: "flex",
                                  "align-items": "center",
                                  gap: "8px",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v("文件：" + _vm._s(_vm.uploadFileName)),
                                ]),
                                _vm._v(" "),
                                _c("el-button", {
                                  staticStyle: {
                                    padding: "0",
                                    color: "#f56c6c",
                                  },
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-close",
                                    size: "mini",
                                  },
                                  on: { click: _vm.clearUploadFile },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放人数：" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          precision: 0,
                          step: 1,
                          "controls-position": "right",
                          placeholder: "请输入发放人数",
                          disabled: true,
                        },
                        model: {
                          value: _vm.form.issueQuantity,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "issueQuantity", $$v)
                          },
                          expression: "form.issueQuantity",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单类型：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.orderType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "orderType", $$v)
                            },
                            expression: "form.orderType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("福卡充值"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发卡类型：" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择发卡类型",
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.sendType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "sendType", $$v)
                            },
                            expression: "form.sendType",
                          },
                        },
                        _vm._l(_vm.sendTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "项目编号：",
                        prop: "projectNumber",
                        rules: _vm.projectNumberRules,
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入项目编号" },
                        model: {
                          value: _vm.form.projectNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "projectNumber", $$v)
                          },
                          expression: "form.projectNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "申请编号：", prop: "applicationNumber" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入申请编号" },
                        model: {
                          value: _vm.form.applicationNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "applicationNumber", $$v)
                          },
                          expression: "form.applicationNumber",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "公司：",
                        prop: "companyId",
                        rules: _vm.formRules.companyId,
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择公司",
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.form.companyId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "companyId", $$v)
                            },
                            expression: "form.companyId",
                          },
                        },
                        _vm._l(_vm.companyOptions, function (company) {
                          return _c("el-option", {
                            key: company.id,
                            attrs: { label: company.name, value: company.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "销售总价：",
                        prop: "salesPrice",
                        rules: _vm.formRules.salesPrice,
                      },
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          precision: 2,
                          step: 0.01,
                          min: 0,
                          disabled: true,
                        },
                        model: {
                          value: _vm.form.salesPrice,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "salesPrice", $$v)
                          },
                          expression: "form.salesPrice",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "发放总面值：",
                        prop: "totalFaceValue",
                        rules: _vm.formRules.totalFaceValue,
                      },
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          precision: 2,
                          step: 0.01,
                          min: 0,
                          disabled: true,
                        },
                        model: {
                          value: _vm.form.totalFaceValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "totalFaceValue", $$v)
                          },
                          expression: "form.totalFaceValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.form.fuCardId && _vm.selectedCard
                    ? _c("el-form-item", { attrs: { label: "福卡详情：" } }, [
                        _c("div", { staticClass: "card-detail-container" }, [
                          _c("div", { staticClass: "card-detail-row" }, [
                            _c("span", { staticClass: "card-detail-label" }, [
                              _vm._v("卡片ID："),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "card-detail-value" }, [
                              _vm._v(_vm._s(_vm.selectedCard.id)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-detail-row" }, [
                            _c("span", { staticClass: "card-detail-label" }, [
                              _vm._v("卡片名称："),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "card-detail-value" }, [
                              _vm._v(_vm._s(_vm.selectedCard.card_name)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.selectedCard.description
                            ? _c("div", { staticClass: "card-detail-row" }, [
                                _c(
                                  "span",
                                  { staticClass: "card-detail-label" },
                                  [_vm._v("卡片描述：")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "card-detail-value" },
                                  [_vm._v(_vm._s(_vm.selectedCard.description))]
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "福卡有效期：",
                        prop: "cardTimeRange",
                        rules: _vm.formRules.cardTimeRange,
                      },
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetimerange",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "range-separator": "-",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                          editable: false,
                        },
                        model: {
                          value: _vm.form.cardTimeRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "cardTimeRange", $$v)
                          },
                          expression: "form.cardTimeRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "发放时间：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.exeType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "exeType", $$v)
                            },
                            expression: "form.exeType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("立即发放"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            { attrs: { label: "2" } },
                            [
                              _vm._v("预约发放时间\n              "),
                              _c("el-date-picker", {
                                staticStyle: { "margin-left": "4px" },
                                attrs: {
                                  type: "datetime",
                                  placeholder: "选择日期时间",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                },
                                model: {
                                  value: _vm.form.exeTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "exeTime", $$v)
                                  },
                                  expression: "form.exeTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "内部备注：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", type: "textarea" },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注：" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入", type: "textarea" },
                        model: {
                          value: _vm.form.innerRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "innerRemark", $$v)
                          },
                          expression: "form.innerRemark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("关闭")]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.submitting,
                    disabled: _vm.submitting,
                  },
                  on: { click: _vm.submit },
                },
                [_vm._v("确认发放")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("ProjectRechargeRecordConfirm", {
        ref: "projectRechargeRecordConfirmRef",
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }